import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from "rxjs/Observable";

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';

import * as globalConst from './../../../../constants';

@Injectable()
export class ExperienceInsertService {

	private apiUrl = globalConst.baseAPI;
	constructor(private http: Http) { }

	insertExperience(token, experience: any) {
		console.log(experience);










		return this.http
		.post(this.apiUrl + "experiences/v1/insertexperience", experience, JSON.parse(localStorage.getItem('yara.connectionHeader')))
		.map((res: Response) => res.json())
		.catch(e => {
			if (e.status === 401) {
				return Observable.throw('Unauthorized');
			}
		});
	}

}



// WEBPACK FOOTER //
// ./src/app/experience/service/experience-insert/experience-insert.service.ts